import api from '../requests';
import moment from 'moment';
import { filterString, toUpper, isEmptyArray } from '../../util/functions';
const FileDownload = require('js-file-download');
import queryString from 'query-string';

const ALL_ORDERS_CATEGORY = [6, 8, 1000, 6209, 7094, 7168, 7166];

export function getOrderQueryString (params) {
  let queryParams = {
    symbol: toUpper(params.symbol),
    mpid: toUpper(params.mpid),
    startDate: params.startDate,
    endDate: params.endDate,
    startTime: params.startTime,
    endTime: params.endTime,
    orderEnterStartTime: params.orderEnterStartTime,
    orderEnterEndTime: params.orderEnterEndTime,
    side: filterString(params.side),
    linkId: params.linkId,
    linkAtsId: params.linkAtsId,
    orderCapacity: params.orderCapacity,
    clientOrderId: params.clientOrderId,
    orderStatus: filterString(params.orderStatus),
    orderId: params.orderId,
    minPrice: params.minPrice,
    maxPrice: params.maxPrice,
    minSize: params.minSize,
    maxSize: params.maxSize,
    category: filterString(params.category),
    tifFilter: filterString(params.tifFilter),
    sortDir: params.sortDir,
    sortOn: params.sortOn
  };
  return queryString.stringify(queryParams);
}

export async function getOrders (params, sort) {
  if (isEmptyArray(params.category)) {
    params.category = ALL_ORDERS_CATEGORY;
  }
  let orderQueryObject = { ...params, ...sort };
  // console.log('param', orderQueryObject);
  let query = getOrderQueryString(orderQueryObject);
  // console.log(query);

  const response = await api.request({
    method: 'get',
    url: `/internal/order-data?${query}`
  });
  return response.data;
}

export async function getChildOrders (params, sort) {
  params.category = ALL_ORDERS_CATEGORY;
  let orderQueryObject = { ...params, ...sort };
  //  console.log('param', orderQueryObject);
  let query = getOrderQueryString(orderQueryObject);
  //  console.log(query);

  const response = await api.request({
    method: 'get',
    url: `/internal/order-data?${query}`
  });
  return response.data;
}

export async function downloadOrders (params) {
  // always provide category ,its needed for indexing
  if (isEmptyArray(params.category)) {
    params.category = ALL_ORDERS_CATEGORY;
  }
  let query = getOrderQueryString(params);
  //  console.log(query);

  const response = await api.request({
    method: 'get',
    responseType: 'blob',
    url: `/internal/order-data/download?${query}`
  });

  FileDownload(response.data, `ECN_Order-${moment().format('MM/DD/YYYY')}.csv`);
}

export async function getOrderFixMsgs (params) {
  //  console.log('param', params);

  const response = await api.request({
    method: 'get',
    url: `/internal/order-data/fix-msg`,
    params: {
      orderDate: params.orderDate,
      category: params.category,
      clientOrderId: params.clientOrderId,
      userId: params.userId
    }
  });
  return response.data;
}

/// OPEN ORDER

export async function getOpenOrders (params, sort) {
  let orderQueryObject = { ...params, ...sort };
  // console.log('param', orderQueryObject);
  let query = getOrderQueryString(orderQueryObject);
  // console.log(query);

  const response = await api.request({
    method: 'get',
    url: `/internal/order-data/open/?${query}`
  });
  return response.data;
}

export async function downloadOpenOrders (params) {
  let query = getOrderQueryString(params);

  const response = await api.request({
    method: 'get',
    responseType: 'blob',
    url: `/internal/order-data/open/download?${query}`
  });

  FileDownload(response.data, `ECN_Open_Order-${moment().format('MM/DD/YYYY')}.csv`);
}
